// 医院感染率数据API服务
import request from '@/utils/request';

// 获取医院感染率列表
export function getHospitalInfectionList(params) {
  return request({
    url: '/hospital-infection/list',
    method: 'get',
    params: {
      ...params,
      currentPage: params.currentPage,
      pageSize: params.pageSize
    }
  });
}

// 获取科室列表
export function getDepartmentList() {
  return request({
    url: '/ward/list',
    method: 'get'
  });
}

// 添加医院感染率数据
export function addHospitalInfection(data) {
  // 计算千日医院感染例次发病率
  if (data.hospitalCount > 0) {
    data.haqi = ((data.newInfectionCasesCount / data.hospitalCount) * 1000).toFixed(2);
  } else {
    data.haqi = 0;
  }
  
  return request({
    url: '/hospital-infection',
    method: 'post',
    data
  });
}

// 更新医院感染率数据
export function updateHospitalInfection(data) {
  console.log('API层 updateHospitalInfection 被调用，参数：', data);
  // 构造与后端一致的字段名
  const submitData = {
    id: data.id,
    stat_date: data.statDate.length === 7 ? data.statDate + '-01' : data.statDate,
    ward_id: data.wardId,
    admission_count: Number(data.admissionCount),
    hospital_count: Number(data.hospitalCount),
    new_infection_cases_count: Number(data.newInfectionCasesCount),
    haqi: data.haqi
  };
  return request({
    url: `/hospital-infection/${data.id}`,
    method: 'put',
    data: submitData
  });
}

// 删除医院感染率数据
export function deleteHospitalInfection(id) {
  return request({
    url: `/hospital-infection/${id}`,
    method: 'delete'
  });
}

// 批量导入医院感染数据
export function importHospitalInfectionData(data) {
  return request({
    url: '/hospital-infection/import',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

// 导出医院感染数据
export function exportHospitalInfectionData(params) {
  return request({
    url: '/hospital-infection/export',
    method: 'get',
    params,
    responseType: 'blob'
  });
}

// 下载导入模板
export function downloadHospitalInfectionTemplate() {
  return request({
    url: '/hospital-infection/template',
    method: 'get',
    responseType: 'blob'
  });
}

// 获取统计数据
export function getHospitalInfectionStatistics(params = {}) {
  return request({
    url: '/hospital-infection/statistics',
    method: 'get',
    params
  });
}

// 按季度获取医院感染数据
export function getHospitalInfectionByQuarter(params) {
  return request({
    url: '/hospital-infection/quarter',
    method: 'get',
    params
  });
}